"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseInput, type BaseInputProps } from "./input";
import ConEdisonInput from "./input.con-edison";

export function Input(props: BaseInputProps) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return <ConEdisonInput {...props} />;

    default:
      return <BaseInput {...props} />;
  }
}
